import React from "react";
import Card from "../../assets/HowToSvg.svg";
import CustomText from "../CustomText";
import Colors from "../../config/Colors";

interface SlideProps {
  title?: string | JSX.Element;
  icon?: any;
  desciption?: string | JSX.Element;
  iconTop?: string | number;
  textBottom?: string | number;
  iconRight?: string | number;
  iconLeft?: string | number;
}

function HowToPlaySlide({
  title,
  icon,
  desciption,
  iconTop,
  textBottom,
  iconRight,
  iconLeft,
}: SlideProps) {
  return (
    <div className="cardHowToPlaySlideContainer">
      <div className="cardHowToPlaySvgContainer">
        <img src={Card} alt="" className="cardHowToPlaySvg" />
      </div>
      <div
        className="cardHowToPlayIconContainer"
        style={{
          top: iconTop || 0,
          right: iconRight || 0,
          left: iconLeft || 0,
        }}
      >
        {icon}
      </div>
      <div
        className="cardHowToPlaySliceTextContainer"
        style={{ bottom: textBottom || 10 }}
      >
        <div className="cardHowToPlaySliceText">
          <CustomText
            weight="900"
            size="medium"
            color={Colors.primary}
            marginBottom={10}
            marginTop={20}
            style={{ textAlign: "center" }}
          >
            {title}
          </CustomText>
          <CustomText weight="500" size="small" color={Colors.blueGray}>
            {desciption}
          </CustomText>
        </div>
      </div>
    </div>
  );
}

export default HowToPlaySlide;
